import { axiosClient, axiosSSOConfigPrivate } from '../../api';
import { API_USERS_DISTRIBUTION_LIST } from '../urls';

export const distributionList = async (id = '') =>
  axiosClient.post(`${API_USERS_DISTRIBUTION_LIST}/${id}`, {}, axiosSSOConfigPrivate());
